
import ApplicationEvents from 'components/applicationEvents';
import { _I_ } from 'components/translate';
import { IconFontAwesome, IconGlyphicon } from 'generics/icons';


const EmailVerificationStateIcon = ({ creds })  =>  {
    const {  haveEmailVerification,  needEmailVerification,  } = creds;

    const  visual = haveEmailVerification ?
                        "success" : (needEmailVerification ? "danger" : "warning");
    return <IconFontAwesome type="envelope" fixedWidth
                mixClasses={[ `text-${visual}` ]}
                title={_I_(`EmailVerificationStateIcon.${visual}`)} />;
}


const TwoFactorStateIcon = ({ creds })  =>  {
    const {  have2step,  need2step,  } = creds;

    const  visual = have2step ? "success" : (need2step ? "danger" : "warning");

    return <IconFontAwesome type="shield" fixedWidth
                mixClasses={[ `text-${visual}` ]}
                title={_I_(`TwoFactorStateIcon.${visual}`)} />;
}


export const CredentialsIcon = ({ creds })  =>  {
    creds = creds||{};
    return (
        <div className="credentials-icon"  >
          &nbsp;{creds.nick || `User #[ ${creds.userId} ]`}
        </div>
      );
}


const LimitedAccountPanelHandleRelogin = ()  =>  ApplicationEvents.emit_async("auth.goToRelogin", "LimitedAccountPanelHandleRelogin");


const WarnLimitedDueTwoStep = ({creds})  =>  {
  return  <li>
            <div><TwoFactorStateIcon creds={creds} />&nbsp;
                {_I_("LimitedAccountPanel.2step.reason")}</div>
            <div><a href={_I_("LimitedAccountPanel.2step.href")}>&nbsp;
                {_I_("LimitedAccountPanel.2step.link")}
            </a></div>
          </li>;
}


const WarnLimitedDueEmailVerification = ({creds, steamArgs})  =>  {
  const href = `${_I_("LimitedAccountPanel.email.href")}${steamArgs}`;
  return  <li>
            <div><EmailVerificationStateIcon creds={creds} />&nbsp;
                {_I_("LimitedAccountPanel.email.reason")}</div>
            <div><a href={href}>
                {_I_("LimitedAccountPanel.email.link")}
            </a></div>
          </li>;
}


export const LimitedAccountPanel = ({ creds })  =>  {
    creds = (creds || {});
    const { steamAppId, steamId } = creds;
    const steamArgs = (steamAppId && steamId) ? `?app_id=${steamAppId}&steam_id=${steamId}` : "";

    const limitedDueTwoStep = !!(creds.need2step && (!creds.have2step));
    const limitedDueEmailVerification = !!(creds.needEmailVerification && (!creds.haveEmailVerification));

    if ( !(limitedDueTwoStep || limitedDueEmailVerification) )  {
      return null;
    }

    return (<div className="alert alert-warning">
              <IconGlyphicon type="warning-sign"/>&nbsp;{_I_("LimitedAccountPanel.title")}
              <ul>
                {limitedDueTwoStep && (
                    <WarnLimitedDueTwoStep creds={creds} />
                  )}
                {limitedDueEmailVerification && (
                    <WarnLimitedDueEmailVerification creds={creds} steamArgs={steamArgs} />
                  )}
                <li>
                  <div>{_I_("LimitedAccountPanel.conclusion")}</div>
                  <div><a onClick={LimitedAccountPanelHandleRelogin}>{_I_("LimitedAccountPanel.relogin")}</a></div>
                </li>
              </ul>
            </div>);
}